import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-factory',
  templateUrl: './factory.component.html',
  styleUrls: ['./factory.component.css']
})
export class FactoryComponent implements OnInit {
    factoryId;

    public edit?: Edit;

    public selectListCompanies: BusinesscoItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.factoryId = this.stateService.getStateParams()['factory_id'];
    }

    private async loadEdit() {
        if (!!this.factoryId) {
            this.edit = (await this.datatask.Post(2027, { factory_id: this.factoryId }))[0];
        }
    }

    private async loadCompanies(): Promise<void> {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2028, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadCompanies();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    factory_id: string;
    factory_name: string;
    businessco_no: number;
    factory_id_url: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('factory', {
//        templateUrl: 'views/components/views/factory/factory.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'factoryService', 'logisticService', function ($stateParams, stateService, translateService, modalService, factoryService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let factoryId = $stateParams.factory_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListCompanies: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await factoryService.getEdit({ factory_id: factoryId }))[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = (await logisticService.listCompanies());
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                factoryService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadCompanies();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
